<template>
  <div id="app">
    <app-header class="app-header" />
    <router-view/>
  </div>
</template>

<script>
import AppHeader from './AppHeader'

export default {
  name: 'App',
  components: {
    AppHeader,
  },
  methods: {
    addBrowserDetectionClasse () {
      const ua = navigator.userAgent
      const isSafari = /AppleWebKit.*Safari\//i.test(ua) && !ua.includes('Chrome')
      const isIOSSafari = isSafari && /iPhone|iPad|iPod/.test(ua)
      if (isSafari) document.documentElement.classList.add('safari')
      if (isIOSSafari) document.documentElement.classList.add('ios-safari')
    }
  },
  mounted () {
    this.addBrowserDetectionClasse()
  },
}
</script>

<style lang="sass">
@import '~styles/fonts'
@import '~styles/reset'
@import '~styles/base'
@import '~styles/forms'

#app
  overflow: hidden

  .app-header
    position: fixed
    left: 0
    right: 0
    top: 0
</style>



// WEBPACK FOOTER //
// src/App.vue